import React from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetOwnEndorsementsGetOwnEndorsementsDto as EndorsementDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { endorsementApi } from '../../../httpclient';
import { asLoadable } from '../../../types';
import { IOwnEndorsementContext, OwnEndorsementContext } from '../../../services/contexts';

export const OwnEndorsementProvider: React.FC<{ children: any }> = ({ children }) => {
  const {
    result,
    errorObject,
    loading,
    callApi: loadOwnEndorsements,
  } = useApi({
    apiFunction: () => endorsementApi.getOwnEndorsements(),
    callApiOnInit: true,
  });

  const value: IOwnEndorsementContext = {
    ownEndorsements: asLoadable<EndorsementDto[]>(result, errorObject, loading),
    refresh: loadOwnEndorsements,
  };

  return <OwnEndorsementContext.Provider value={value}>{children}</OwnEndorsementContext.Provider>;
};
